<template>
  <v-chip :color="meta.color" small dark>
    {{ meta.text }}
  </v-chip>
</template>

<script>
import { findStatusMeta } from "../constants";

export default {
  name: "ResourceStatusChip",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    meta() {
      return findStatusMeta(this.status);
    },
  },
};
</script>

